var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaitdaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 30,
    viewBox: "0 0 108.000000 20",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505 390 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0 -12 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 344 c-3 -9 -6 -39 -6 -68 0 -65 -19 -86 -85 -94 -57 -6 -54 -27 4 -26 31 1 49 8 70 28 l29 27 27 -26 c16 -14 38 -28 50 -31 36 -9 118 0 123 14 3 9 -14 12 -63 12 -60 0 -69 3 -96 29 -26 26 -29 36 -29 90 0 58 -11 79 -24 45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706 344 c-20 -20 -23 -138 -3 -132 7 3 13 27 15 60 2 46 7 57 22 61 11 3 20 10 20 16 0 16 -36 13 -54 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 325 c-19 -29 -11 -60 18 -76 26 -14 64 2 73 31 9 30 -19 70 -50 70 -15 0 -31 -10 -41 -25z m61 -6 c10 -16 -4 -59 -19 -59 -17 0 -28 27 -21 51 7 21 30 25 40 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 332 c-38 -42 -5 -92 61 -92 44 0 38 23 -9 30 -26 4 -34 10 -34 25 0 15 8 21 32 23 17 2 34 10 37 18 8 22 -67 19 -87 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 324 c-20 -13 -22 -24 -22 -95 0 -60 3 -80 13 -77 7 3 13 29 15 71 3 63 5 68 32 82 17 9 30 20 30 25 0 15 -43 12 -68 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 304 c-19 -19 -21 -64 -3 -88 15 -20 117 -36 117 -19 0 19 -25 33 -57 33 -65 0 -51 56 14 62 20 2 38 9 41 16 6 19 -93 16 -112 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 250 c-8 -12 -13 -11 63 -14 45 -2 62 1 62 11 0 16 -115 19 -125 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 76 c0 -7 -9 -16 -20 -19 -14 -3 -20 -14 -20 -31 0 -21 5 -26 25 -26 23 0 25 4 25 45 0 25 -2 45 -5 45 -3 0 -5 -6 -5 -14z m-5 -46 c0 -7 -6 -15 -12 -18 -8 -2 -13 5 -13 18 0 13 5 20 13 18 6 -3 12 -11 12 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 76 c0 -7 -9 -16 -21 -19 -32 -9 -22 -51 14 -55 26 -3 27 -2 27 42 0 25 -4 46 -10 46 -5 0 -10 -6 -10 -14z m0 -46 c0 -21 -15 -27 -25 -10 -7 12 2 30 16 30 5 0 9 -9 9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 43 c4 -45 24 -55 21 -11 -2 48 -2 48 -14 48 -6 0 -9 -16 -7 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 45 c-9 -23 3 -45 26 -45 16 0 20 7 20 30 0 23 -4 30 -20 30 -11 0 -23 -7 -26 -15z m36 -15 c0 -11 -4 -20 -9 -20 -14 0 -23 18 -16 30 10 17 25 11 25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 30 c0 -17 5 -30 10 -30 6 0 10 13 10 30 0 17 -4 30 -10 30 -5 0 -10 -13 -10 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 53 c-4 -3 -7 -17 -7 -30 0 -18 5 -23 25 -23 21 0 25 5 25 30 0 22 -5 30 -18 30 -10 0 -22 -3 -25 -7z m25 -35 c-15 -15 -26 -4 -18 18 5 13 9 15 18 6 9 -9 9 -15 0 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 45 c-10 -24 4 -45 29 -45 19 0 23 5 23 30 0 25 -4 30 -23 30 -13 0 -26 -7 -29 -15z m36 -15 c0 -11 -4 -20 -9 -20 -14 0 -23 18 -16 30 10 17 25 11 25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 33 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaitdaLogo);
export default __webpack_public_path__ + "static/media/daitda-logo.f868f783ca2af9b07e139983bd668eb3.svg";
export { ForwardRef as ReactComponent };